import React from 'react';
import { Sun, Contrast } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';
import './ThemeToggle.css';

function ThemeToggle() {
  const { theme, setTheme } = useTheme();

  // Toggle between light and dark only
  const handleToggle = () => {
    setTheme(theme === 'light' ? 'dark' : 'light');
  };

  const getAriaLabel = () => {
    const nextTheme = theme === 'light' ? 'dark' : 'light';
    return `Current theme: ${theme}. Click to switch to ${nextTheme} mode.`;
  };

  return (
    <button
      className="theme-toggle-button"
      onClick={handleToggle}
      aria-label={getAriaLabel()}
      title={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
    >
      <span className={`theme-toggle-icon ${theme === 'light' ? 'icon-light' : 'icon-dark'}`}>
        {theme === 'light' ? <Sun size={20} /> : <Contrast size={20} />}
      </span>
    </button>
  );
}

export default ThemeToggle;
